import { type RequestContext } from '~/types/RequestContext';

import { BettingInsightsComponent } from '../BettingInsightsConfiguration';
import { type EsIndex } from '../types';

import { type BettingInsightsResultsCategoriesConfig } from './BettingInsightsResultsCategories';

export interface BettingInsightsResultsConfig<TIndex extends EsIndex> {
	categories: (
		this: BettingInsightsResults<TIndex>,
	) => BettingInsightsResultsCategoriesConfig<TIndex>;
	labelledBy: string;
	propsName: string;
}

export class BettingInsightsResults<TIndex extends EsIndex>
	extends BettingInsightsComponent
	implements BettingInsightsResultsConfig<TIndex>
{
	categories: () => BettingInsightsResultsCategoriesConfig<TIndex>;
	labelledBy: string;
	propsName: string;

	constructor({
		categories,
		labelledBy,
		propsName,
		...requestContext
	}: BettingInsightsResultsConfig<TIndex> & RequestContext) {
		super(requestContext);
		this.categories = categories.bind(this);
		this.labelledBy = labelledBy;
		this.propsName = propsName;
	}

	static withRequestContext<TIndex extends EsIndex>(
		requestContext: RequestContext,
		config: BettingInsightsResultsConfig<TIndex>,
	) {
		return new this<TIndex>({
			...requestContext,
			...config,
		});
	}
}
